import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { LogoMark } from "@/components/app/Logo";
import { toast } from "sonner";

export default function Login() {
  const { user, login, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (loading) return <div className="min-h-screen grid place-items-center"><Loader2 className="h-8 w-8 animate-spin text-primary" /></div>;
  if (user) return <Navigate to="/vendors" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email.trim(), password);
      toast.success("Signed in");
      navigate("/vendors");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Sign in failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen relative flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-grid opacity-40 pointer-events-none" aria-hidden />
      <div className="relative w-full max-w-md">
        <div className="flex items-center gap-3 mb-6 justify-center">
          <LogoMark size={52} />
          <div className="leading-tight">
            <div className="font-heading text-[11px] font-bold tracking-[0.28em] text-foreground">NAT HABITAT</div>
            <h1 className="font-heading text-xl font-semibold">BOQ Cost Portal</h1>
            <div className="text-[10px] text-muted-foreground font-mono uppercase tracking-[0.24em]">Vendor Rate Intelligence</div>
          </div>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4 rounded-xl border border-border bg-card p-6" data-testid="login-form">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@company.com" required autoFocus data-testid="login-email" />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" value={password} onChange={e => setPassword(e.target.value)} required data-testid="login-password" />
          </div>
          <Button type="submit" disabled={submitting} className="w-full" data-testid="login-submit">
            {submitting ? <><Loader2 className="h-4 w-4 mr-2 animate-spin" /> Signing in…</> : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
